export const BRAIN_API = `${process.env.REACT_APP_BACKEND_URL}/api/brain/v1`;

export const getCsrfToken = () =>
  document.cookie
    .split("; ")
    .find((c) => c.startsWith("lr_csrf="))
    ?.split("=")[1] || "";

export const fmtDate = (iso) => (iso ? iso.slice(0, 10) : "—");
